module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KM-13924cc7e8c9c1a04e34f748674ed3d5.png";